import React from 'react';
import { THEME } from '../utils/theme';
import { FREE_DELIVERY_RADIUS_KM } from '../utils/locationConstants';
import { calculatePrice as calculatePriceUtil } from '../utils/deliveryUtils';

const DeliveryChargeInfo = ({ deliveryDistance, numberOfPlates, plateSize, radiusKm = FREE_DELIVERY_RADIUS_KM }) => {
  if (deliveryDistance === null || deliveryDistance === undefined) return null;

  const pricing = calculatePriceUtil(plateSize, numberOfPlates, deliveryDistance, radiusKm);

  const styles = {
    container: (distance, plates) => ({
      marginTop: '10px',
      padding: '10px',
      backgroundColor: distance <= radiusKm ? THEME.info.light : (plates >= 2 ? THEME.info.light : THEME.warning.light),
      borderLeft: `4px solid ${distance <= radiusKm ? THEME.info.main : (plates >= 2 ? THEME.info.main : THEME.warning.main)}`,
      borderRadius: '4px',
      color: distance <= radiusKm ? THEME.info.dark : (plates >= 2 ? THEME.info.dark : THEME.warning.dark),
      fontSize: '13px',
      lineHeight: '1.5'
    }),
    chargeText: {
      marginTop: '5px'
    },
    tipText: {
      marginTop: '5px',
      fontStyle: 'italic',
      fontSize: '12px'
    }
  };

  return (
    <div style={styles.container(deliveryDistance, numberOfPlates)}>
      {deliveryDistance <= radiusKm ? (
        <div style={styles.chargeText}>
          <strong>🎉 Free Delivery!</strong> You are within {radiusKm}km radius.
        </div>
      ) : numberOfPlates >= 2 ? (
        <div style={styles.chargeText}>
          <strong>🎉 Free Delivery!</strong> Free delivery for 2 or more plates.
        </div>
      ) : numberOfPlates === 1 ? (
        <div style={styles.chargeText}>
          <strong>💰 Delivery Charge:</strong> ₹{pricing.deliveryCharge}
          <div style={styles.tipText}>
            💡 Tip: Order 2+ plates for free delivery!
          </div>
        </div>
      ) : (
        <div style={styles.chargeText}>
          <strong>ℹ️</strong> Select number of plates to see delivery charge.
        </div>
      )}
    </div>
  );
};

export default DeliveryChargeInfo;
